import React, { createContext, PropsWithChildren } from "react";
import { Moment } from "moment";

type Props = {
    time: Moment;
};

interface Context {
    time: Moment;
}

export const DataContext = createContext({} as Context);

export const DataProvider: React.FC<Props> = function ({ time, children }: PropsWithChildren<Props>) {
    const value = {
        time
    } as Context;

    return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
